import React from 'react';
import { Box, Grid, Card, Skeleton } from '@mui/material';

export const DocumentSkeleton: React.FC = () => {
  return (
    <>
      {Array.from({ length: 8 }, (_, index) => index).map((_, i) => (
        <Grid item xs={12} sm={6} md={4} lg={3} key={`skel-${i}`}>
          <Card variant="outlined" sx={{ borderRadius: 2, borderColor: 'divider', p: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 1 }}>
              <Skeleton variant="circular" width={40} height={40} />
              <Box sx={{ flexGrow: 1 }}>
                <Skeleton variant="text" width="60%" height={24} />
                <Skeleton variant="text" width="40%" height={16} />
              </Box>
            </Box>
          </Card>
        </Grid>
      ))}
    </>
  );
};
